import { render, staticRenderFns } from "./RaceInfo.vue?vue&type=template&id=315b570d&scoped=true&"
import script from "./RaceInfo.vue?vue&type=script&lang=js&"
export * from "./RaceInfo.vue?vue&type=script&lang=js&"
import style0 from "./RaceInfo.vue?vue&type=style&index=0&id=315b570d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b570d",
  null
  
)

export default component.exports